export default [
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Présences",
      layout: "dashboard",
    },
    path: "/attendances",
    name: "attendances",
    component: () => import("@/layouts/index/AttendanceIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Présences",
          layout: "dashboard",
        },
        path: "index",
        name: "attendances-index",
        component: () => import("@/views/attendances/Listing.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Ajouter une présence",
          layout: "dashboard",
        },
        path: "create",
        name: "attendances-create",
        component: () => import("@/views/attendances/Create.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier une présence",
          layout: "dashboard",
        },
        path: ":reference/edit",
        name: "attendances-edit",
        component: () => import("@/views/attendances/Edit.vue"),
      },
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Salaires",
          layout: "dashboard",
        },
        path: "salaries",
        name: "attendances-salaries",
        component: () => import("@/views/attendances/Salaries.vue"),
      },
    ],
  },
];
